import withSharedStyles from "../theme/Shared.style";

const withCustomStyles = withSharedStyles(theme => ({
  salientFeaturesRow: {
    paddingBottom: 8,
    paddingTop: 8
  },
  iconItem: {
    paddingRight: 16,
    color: theme.tokens.color.brandText,
    "& svg": { fontSize: theme.tokens.iconSize.xl }
  }
}));

export default withCustomStyles;
